function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("metadata", null, "Svg Vector Icons : http://www.onlinewebfonts.com/icon");

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)"
}, React.createElement("path", {
  d: "M4856.3,4984.1c-30.7-19.2-490.5-471.3-1019.3-1000.2c-1042.3-1046.2-1007.8-1004-973.3-1180.3c17.2-93.9,132.2-208.8,226.1-226.1c172.4-32.6,159-44.1,908.2,705.1l695.5,693.6l3.8-4286.2l5.7-4286.2l40.2-51.7c74.7-101.6,136-132.2,256.7-132.2c120.7,0,182,30.6,256.7,132.2l40.3,51.7l5.7,4286.2l3.8,4286.2l695.5-693.6c749.2-749.2,735.8-737.7,908.2-705.1c93.9,17.2,208.8,132.2,226.1,226.1c34.5,176.3,69,134.1-982.9,1187.9c-534.6,536.5-994.4,986.8-1023.2,1002.1C5057.5,5032,4925.3,5028.2,4856.3,4984.1z"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/sort-arrow-up.e674796d.svg";
export { SvgComponent as ReactComponent };